module.exports = "/build/web/svg/calendar.99c71c27da69a31407ac33b63881ccb9.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/calendar.svg
// module id = 99
// module chunks = 24